import api from './api';
import { IHistory, IObject } from 'interfaces/applicant.interface';
import { IPageableResponse } from '../interfaces/shared.interface';

const _resourceUrl = '/front';

export const getKpuState = (): Promise<{ objects: IObject[] }> => {
  return api.get(`${_resourceUrl}/kpu/state`);
};

export const getInventoryHistory = (
  params: Record<string, number>,
): Promise<IPageableResponse<IHistory>> => {
  return api.get(`${_resourceUrl}/inventory/history`, { params });
};
